import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LayoutFooterPage from '../shared/layout/LayoutFooterPage';
import withApiData from '../../services/withApiData';
import { performApiRequest } from '../../redux/apiData';
import ContentLoader from '../shared/ui/ContentLoader';
import ErrorBlock from '../ErrorBlock';
import { getErrorBlockProps } from '../../constants/errorMessages';
import LayoutBase from '../shared/layout/LayoutBase';
import get from 'lodash.get';
import WithSettings from '@/components/WithSettings';
var connectApiData = withApiData({
  footerPage: 'getFooterPage'
}, function (_ref) {
  var match = _ref.match;
  var _match$params = match.params,
    projectSlug = _match$params.projectSlug,
    env = _match$params.env,
    footerPageSlug = _match$params.footerPageSlug;
  return {
    footerPage: {
      projectSlug: projectSlug,
      env: env,
      footerPageSlug: footerPageSlug
    }
  };
});
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getNewFooterPage: function getNewFooterPage(_ref2) {
      var params = _ref2.params;
      dispatch(performApiRequest('getPage', params));
    }
  };
};

// You may ask: why store the titles of these pages in the frontend, statically?
// That is due to the fact the CMS can't serve these types of pages (yet).
var PAGETITLE = {
  about: 'Over Homestudios',
  disclaimer: 'Disclaimer',
  'privacy-statement': 'Privacy Statement'
};
var FooterPageContainer = /*#__PURE__*/function (_Component) {
  function FooterPageContainer() {
    _classCallCheck(this, FooterPageContainer);
    return _callSuper(this, FooterPageContainer, arguments);
  }
  _inherits(FooterPageContainer, _Component);
  return _createClass(FooterPageContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        getNewFooterPage = _this$props.getNewFooterPage,
        match = _this$props.match;
      var footerPageSlug = match.params.footerPageSlug;
      var oldFooterPageSlug = prevProps.match.params.footerPageSlug;
      if (oldFooterPageSlug !== footerPageSlug) {
        getNewFooterPage(match.params);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        match = _this$props2.match,
        footerPage = _this$props2.footerPage,
        settings = _this$props2.settings,
        renderWidth = _this$props2.renderWidth;
      var footerPageSlug = match.params.footerPageSlug;
      var pageNotFound = get(footerPage, 'request.response.status') === 404;
      var title = footerPageSlug && settings ? "".concat(PAGETITLE[footerPageSlug], " - ").concat(settings.siteName) : undefined;
      var meta = footerPage.data ? {
        metaTitle: title
      } : {};
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: true
      };
      return __jsx(LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "contentTypes_FooterPage_LayoutBase"
      }, footerPage.data && !pageNotFound && __jsx(LayoutFooterPage, {
        footerPage: footerPage.data,
        renderWidth: renderWidth,
        title: title,
        "data-id": "contentTypes_FooterPage_LayoutFooterPage"
      }), footerPage.request.networkStatus === 'loading' && __jsx(ContentLoader, {
        "data-id": "contentTypes_FooterPage_ContentLoader"
      }), pageNotFound && __jsx(ErrorBlock, _extends({}, getErrorBlockProps(match, 'footerpage', 404), {
        "data-id": "contentTypes_FooterPage_ErrorBlock"
      })));
    }
  }]);
}(Component);
export default WithSettings(connectApiData(connect(null, mapDispatchToProps)(FooterPageContainer)));